<template>
  <div id="app">
    <div class="page-wrapper">
      <div class="container">
        <h1 class="title">MAGICUBE GROUP - Recurring Payment Authorization Terms</h1>

        <p><strong>Contracting Party (User):</strong> ________________________</p>
        <p><strong>Service Provider (Authorized Party):</strong> MAGICUBE GROUP</p>
        <p><strong>Effective Date:</strong> Upon selecting "I Agree" and completing the initial payment</p>

        <div class="article-section">
          <h2>ARTICLE 1 - SERVICE DEFINITION</h2>

          <h3>Authorization:</h3>
          <p>The User authorizes MAGICUBE GROUP to debit amounts from their account via the selected payment method (credit card, debit card, digital wallets, etc.) for the automatic renewal of the subscription service.</p>

          <h3>Service Coverage:</h3>
          <ul>
            <li>Unlimited access to 200+ works (including new releases)</li>
            <li>Ad-free and buffer-free content</li>
          </ul>
        </div>

        <div class="article-section">
          <h2>ARTICLE 2 - USER OBLIGATIONS</h2>

          <h3>Payment Management:</h3>
          <ol>
            <li>Maintain sufficient balance/funds in the account</li>
            <li>Update payment information within 48 hours via the App/Website</li>
          </ol>
          <p><strong>App:</strong> My Account > Payments</p>
          <p><strong>Website:</strong> My Account > Manage Subscription</p>

          <h3>Usage Restrictions:</h3>
          <ul>
            <li>Authorization is valid only for accounts under the User's name</li>
            <li>Prohibited use for illegal operations (e.g., money laundering, unauthorized withdrawals)</li>
          </ul>
        </div>

        <div class="article-section">
          <h2>ARTICLE 3 - PLATFORM RESPONSIBILITIES</h2>

          <h3>Commitments:</h3>
          <ul>
            <li>Immediate activation of service upon successful charge</li>
            <li>Secure data storage (PCI-DSS standard)</li>
          </ul>

          <h3>Disclaimer Scenarios:</h3>
          <ul>
            <li>Insufficient balance or operational limits</li>
            <li>Force majeure events (network instability, bank maintenance)</li>
            <li>Payment information not updated by the User</li>
          </ul>
        </div>

        <div class="article-section">
          <h2>ARTICLE 4 - PLANS AND CHARGES</h2>

          <h3>Weekly Plan:</h3>
          <ul>
            <li>Price: The price paid by the local APP operation shall prevail</li>
            <li>Period: 1 Week</li>
            <li>Renewal Rule: Charge 24 hours before the period ends</li>
          </ul>

          <h3>Monthly Plan:</h3>
          <ul>
            <li>Price: The price paid by the local APP operation shall prevail</li>
            <li>Period: 1 Month</li>
            <li>Renewal Rule: Charge 24 hours before the period ends</li>
          </ul>

          <h3>Quarterly plan:</h3>
          <ul>
            <li>Price: The price paid by the local APP operation shall prevail</li>
            <li>Period: 3 Month</li>
            <li>Renewal Rule: Charge 24 hours before the period ends</li>
          </ul>

          <h3>Annual plan:</h3>
          <ul>
            <li>Price: The price paid by the local APP operation shall prevail</li>
            <li>Period: 1 Year</li>
            <li>Renewal Rule: Charge 24 hours before the period ends</li>
          </ul>

          <div class="note-box">
            <p><strong>NOTE:</strong> Price adjustments will be communicated via email with 30 days' advance notice. Continued subscription implies acceptance.</p>
          </div>
        </div>

        <div class="article-section">
          <h2>ARTICLE 5 - CANCELLATION AND REFUNDS</h2>

          <h3>Cancellation by User:</h3>
          <p>Must be performed BEFORE the end of the current billing cycle</p>

          <h3>Cancellation Paths:</h3>
          <p><strong>App:</strong> Account Settings > Cancel Subscription</p>
          <p><strong>Website:</strong> My Account > Manage Subscription</p>

          <p><strong>Debited amounts will not be refunded</strong> (except for duplicate charges)</p>

          <h3>Termination by Platform:</h3>
          <p>In cases of proven bad faith (fraud, violation of terms)</p>
        </div>

        <div class="article-section">
          <h2>ARTICLE 6 - GOVERNING LAW AND DISPUTES</h2>

          <h3>Governing Law:</h3>
          <p>Laws of the Hong Kong Special Administrative Region.</p>

          <h3>Dispute Resolution:</h3>
          <p>The parties shall first attempt to resolve any dispute through amicable negotiation. If negotiation fails, either party may submit the dispute to a court of competent jurisdiction in the state where the service operates.</p>

          <h3>Mandatory Preceding Step:</h3>
          <p>Attempt at mediation is required.</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  data() {
    return {

    }
  },
}
</script>

<style scoped lang="scss">
#app {
  background: #fff;
  padding: 80px 40px;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

.page-wrapper {
  display: flex;
  justify-content: center;
}

.container {
  max-width: 960px;
  width: 100%;
}

.title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

.article-section {
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
}

h2 {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 32px 0 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #4CAF50;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  margin: 24px 0 12px;
}

p,
li {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
  margin: 8px 0;
}

ul,
ol {
  padding-left: 24px;
  margin: 12px 0;
}

strong {
  color: #000;
  font-weight: 600;
}

.note-box {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 16px;
  margin: 20px 0;

  strong {
    color: #856404;
  }
}

/* Style for user signature input */
.container p:first-child {
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  min-height: 24px;
  display: flex;
  align-items: center;
}
</style>
